import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../../utils/AppUtils";
import _ from "lodash";
import { useEffect, useState } from "react";
import { getOfficeListReq } from "../../redux/assignCourse/actions";
const OfficeSelectComp = (props) => {
    const {selectedOfficeList, setSelectedOfficeList, getLeaderBoardData} = props;
    const dispatch = useDispatch();

    const officeListRes = useSelector((state) => state.assignCourse.officeList);
	const [officeList, setOfficeList] = useState([]);
  const [officeListForFilter, setOfficeListForFilter] = useState([]);
  const [searchValue,setSearchValue] = useState('');



    useEffect(()=>{searchOffice()},[])

    const searchOffice = () => {
		// console.log('officeListRes1')
		dispatch(getOfficeListReq({
			module: 'getOfficeListSearch',
			postData: {
				token:  localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
				search: '',
				type: 'report'
			}
		}))
	}

  useEffect(()=>{
    if(searchValue===undefined || _.isEmpty(searchValue)){
      setOfficeList(officeListForFilter);
    }else{
      let tempList= officeListForFilter?.filter((item)=>{return item?.office_name?.toLowerCase().includes(searchValue.toLowerCase()) })
      setOfficeList(tempList)
    }
  },[searchValue])

	useEffect(() => {
		// console.log('officeListRes: ', officeListRes)
		if (!_.isEmpty(officeListRes)) {
			if (officeListRes?.status === 'success') {
				const officeArr = officeListRes?.payload?.payload
				setOfficeList(officeArr);
        setOfficeListForFilter(officeArr);

			} else {
				setOfficeList([])
        setOfficeListForFilter([])
			}
		} else {
			setOfficeList([])
      setOfficeListForFilter([]);
		}
	}, [officeListRes])


    
    const [isAllSelected, setIsAllSelected] = useState(false);
  
    const clickAllSelectedUser = () => {
  
      if (isAllSelected) {
        setSelectedOfficeList([])
        setIsAllSelected(false);
      } else {
        let selectedArr = [];
        for (let index = 0; index < officeListForFilter.length; index++) {
          const item = officeListForFilter[index];
          selectedArr.push(item);
        }
        setSelectedOfficeList(selectedArr);

        if(selectedArr.length===officeListForFilter.length){
          setIsAllSelected(true)
        }
      }
  
    }
  
  
    const addRemindSelectedUser = (item, isRemove) => {
      console.log("inner:::::");
      if (isRemove) {
        let filteredArr = [];
        for (let i = 0; i < selectedOfficeList.length; i++) {
          const element = selectedOfficeList[i];
            if (element.office_id !== item.office_id) {
              filteredArr.push(element);
            }
        }
        setSelectedOfficeList(filteredArr);
        if(filteredArr.length<officeListForFilter.length){
          setIsAllSelected(false)
        }
      } else {
        
        let selectedArr = _.cloneDeep(selectedOfficeList);
        selectedArr.push(item);
        setSelectedOfficeList(selectedArr);
        if(selectedArr.length===officeListForFilter.length){
          setIsAllSelected(true)
        }
      }
    };
    const isExistId = (item) => {
      let isExist = false;
      for (let i = 0; i < selectedOfficeList.length; i++) {
        const element = selectedOfficeList[i];
        
          if (element.office_id === item.office_id) {
            isExist = true;
            break;
          }
      }
  
      return isExist;
    };

    
    return (<>
        <Dropdown data-bs-theme="dark">
              <Dropdown.Toggle
                className="btn-all-fillter"              
                variant="secondary"
               id="dropdown-basic"
               align="end"
              >
                Offices
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <div className="dropdown-menu-filter" id="avail_menu">
                  <div className="dropdown-search">
                    <div className="dropdown-item-se pos-r">
                      <input
                        type="search"
                        className="form-control-search input_field mb-0"
                        placeholder="Search"
                        value={searchValue}
                        onChange={(evt)=>{
                          setSearchValue(evt.target.value);
                        }}
                      />
                      <i className="filter-searchicon"></i>
                    </div>
                  </div>
                  <div className="drop-multiselect">
                    <div className="bdr-row">
                      <div className="form-check checkallvalue" onClick={() => {
                        clickAllSelectedUser()
                      }}>
                        <input
                          aria-label="Select all (6)"
                          tabindex="0"
                          type="checkbox"
                          class="form-check-input"
                          id="selectallvaluecontentType"
                          checked={isAllSelected}
                        />
                        <label className="form-check-label" id="selectallvalue">
                          Select All
                        </label>
                      </div>

                     {officeList.map((item,index)=>{
                        return <div className="form-check"
                        onClick={() => {
                            if (isExistId(item)) {
                              addRemindSelectedUser(item, true);
                            } else {
                              addRemindSelectedUser(item, false);
                            }
                          }}>
                        <input type="checkbox" className="form-check-input" checked={isExistId(item)}/>
                        <label className="form-check-label" id="level">
                          {item.office_name}
                        </label>
                      </div>
                     }) }
                    </div>
                  </div>
                  <div className="filter-btnrow" id="avl_applybtn">
                    <button type="button" className="upload-review-btn" onClick={()=>{
                      setSelectedOfficeList([])
                      setIsAllSelected(false);
                    }}>
                      Cancel
                    </button>
                    <button type="submit" className="upload-review-btn" onClick={()=>{
                        console.log('OfficeListSelected: ',selectedOfficeList)
                        getLeaderBoardData()
                    }}>
                      Apply
                    </button>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
            {false && <Dropdown data-bs-theme="dark">
                <Dropdown.Toggle
                  className="btn-all-fillter"
                  id="dropdown-button-dark-example1"
                  variant="secondary"
                >
                  Roles
                </Dropdown.Toggle>
  
                <Dropdown.Menu>
                  <div className="dropdown-menu-filter" id="avail_menu">
                    <div className="dropdown-search">
                      <div className="dropdown-item-se pos-r">
                        <input
                          type="text"
                          className="form-control-search input_field mb-0"
                          placeholder="Search"
                        />
                        <i className="filter-searchicon"></i>
                      </div>
                    </div>
                    <div className="drop-multiselect">
                      <div className="bdr-row">
                        <div className="form-check checkallvalue">
                          <input
                            aria-label="Select all (6)"
                            tabindex="0"
                            type="checkbox"
                            class="form-check-input"
                            id="selectallvaluecontentType"
                          />
                          <label className="form-check-label" id="selectallvalue">
                            Select All
                          </label>
                        </div>
  
                        <div className="form-check">
                          <input type="checkbox" className="form-check-input" />
                          <label className="form-check-label" id="level">
                            check 1
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="filter-btnrow" id="avl_applybtn">
                      <button type="button" className="cancelbtn btn-primary d-inline">
                        Cancel
                      </button>
                      <button type="submit" className="publishbtn btn-primary d-inline">
                        Apply
                      </button>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>}
        </>)

}
export default OfficeSelectComp;